<template>
  <div class="flex flex-col flex-1">
    <div class="font-semibold py-1">{{ stage.text }}</div>
    <div>
      <!-- runing stage excluded close and approval -->
      <template
        v-if="
          running &&
          ['transfer_approval', 'return_approval'].indexOf(stage.key) === -1
        "
      >
        <label v-if="!resource.statusId" class="mb-2 text-neutral">
          {{ $tc('select_status') }}
        </label>
        <FlotoStatusPicker
          :disabled="disabled"
          :value="statusId"
          :stage="stage.key"
          :module-name="moduleName"
          :as-input="!disabled"
          :allow-clear="false"
          :placeholder="disabled ? '---' : undefined"
          @change="handleChange"
        />
      </template>
      <template
        v-if="
          running &&
          ['transfer_approval', 'return_approval'].indexOf(stage.key) >= 0
        "
      >
        <FlotoStatusPicker
          disabled
          :value="statusId"
          :stage="stage.key"
          :placeholder="$tc('pending')"
          :module-name="moduleName"
        />
      </template>
      <FlotoStatusPicker
        v-else-if="completed"
        :disabled="true"
        :value="statusId"
        :allow-clear="false"
        :stage="stage.key"
        :module-name="moduleName"
        @change="handleChange"
      />
    </div>
  </div>
</template>

<script>
import { StatusComputed } from '@state/modules/status'
export default {
  name: 'StageActionInfo',
  props: {
    stage: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
    completed: { type: Boolean, default: false },
    pending: { type: Boolean, default: false },
    running: { type: Boolean, default: false },
    resource: { type: Object, required: true },
    moduleName: { type: String, required: true },
  },
  computed: {
    ...StatusComputed,
    currurentStatus() {
      if (this.resource.statusId) {
        return this[`${this.moduleName}FindStatusFromId`](
          this.resource.statusId
        )
      }
      return undefined
    },
    statusId() {
      if (this.resource.statusId && this.running) {
        return this.resource.statusId
      }
      const currentList = (this[`${this.moduleName}Status`] || [])
        .filter((o) => o.stage === this.stage.key)
        .map((s) => ({ ...s, text: s.name }))
      return (
        currentList[currentList.length - 1] &&
        currentList[currentList.length - 1].key
      )
    },
  },
  methods: {
    handleChange(data) {
      this.$emit('change', { statusId: data })
    },
  },
}
</script>
